import { AccountBalance, Inventory, PersonAddAlt1 } from "@mui/icons-material";

// Tab configurations
export const CASH_OUT_TABS = [
    {
        id: 0,
        label: "Expense",
        icon: PersonAddAlt1,
        type: "expense",
    },
    {
        id: 1,
        label: "Purchases and Payments",
        icon: Inventory,
        type: "purchase",
    },
    {
        id: 2,
        label: "Employee Advance",
        icon: AccountBalance,
        type: "employee_advance",
    },
];

// Default form values
export const DEFAULT_FORM_VALUES = {
    expense: {
        description: "",
        amount: "",
        selectedExpenseAccount: "",
    },
    purchase: {
        description: "",
        selectedSupplier: "",
        selectedItems: [],
        itemSearchText: "",
        isPaymentMode: false,
        paymentAmount: "",
        purchasePaidAmount: "",
    },
    employeeAdvance: {
        advanceReason: "",
        advanceAmount: "",
        selectedEmployee: "",
    },
    itemCreation: {
        item_name: "",
        item_group: "",
        purchase_rate: "",
    },
};

// Account name patterns
export const ACCOUNT_PATTERNS = {
    CASH: (abbr) => `Petty Cash - ${abbr}`,
    // CASH: (abbr) => `Cash - ${abbr}`,
    CREDITORS: (abbr) => `Creditors - ${abbr}`,
    STORES: (abbr) => `Stores - ${abbr}`,
    MAIN_COST_CENTER: (abbr) => `Main - ${abbr}`,
    COST_OF_GOODS_SOLD: (abbr) => `Cost of Goods Sold - ${abbr}`,
    PAYROLL_PAYABLE: (abbr) => `Payroll Payable - ${abbr}`,
};

// Document name generators
export const DOC_NAME_GENERATORS = {
    JOURNAL_ENTRY: () =>
        `new-journal-entry-${Math.random().toString(36).substr(2, 10)}`,
    JOURNAL_ENTRY_ACCOUNT: () =>
        `new-journal-entry-account-${Math.random().toString(36).substr(2, 10)}`,
    PURCHASE_INVOICE: () =>
        `new-purchase-invoice-${Math.random().toString(36).substr(2, 10)}`,
    PURCHASE_INVOICE_ITEM: () =>
        `new-purchase-invoice-item-${Math.random().toString(36).substr(2, 10)}`,
    PAYMENT_ENTRY: () =>
        `new-payment-entry-${Math.random().toString(36).substr(2, 10)}`,
    ITEM: () => `new-item-${Math.random().toString(36).substr(2, 10)}`,
    UOM_CONVERSION: () =>
        `new-uom-conversion-detail-${Math.random().toString(36).substr(2, 10)}`,
    ITEM_DEFAULT: () =>
        `new-item-default-${Math.random().toString(36).substr(2, 10)}`,
    STOCK_ENTRY_DETAIL: () =>
        `new-stock-entry-detail-${Math.random().toString(36).substr(2, 10)}`,
};

// Default values
export const DEFAULT_VALUES = {
    CURRENCY: "ILS",
    STOCK_UOM: "Nos",
    UOM: "Nos",
    CONVERSION_FACTOR: 1,
    EXCHANGE_RATE: 1,
    NAMING_SERIES: {
        JOURNAL_ENTRY: "ACC-JV-.YYYY.-",
        PURCHASE_INVOICE: "ACC-PINV-.YYYY.-",
        PAYMENT_ENTRY: "ACC-PAY-.YYYY.-",
        ITEM: "STO-ITEM-.YYYY.-",
    },
    MODE_OF_PAYMENT: "Cash",
    PAYMENT_TYPE: "Pay",
    PAYMENT_ORDER_STATUS: "Initiated",
    PRICE_LIST: "Standard Buying",
    COUNTRY_OF_ORIGIN: "Palestinian Territory, Occupied",
    END_OF_LIFE: "2099-12-31",
    MATERIAL_REQUEST_TYPE: "Purchase",
    LETTER_HEAD: "Default",
};

// Validation constants
export const VALIDATION = {
    MIN_AMOUNT: 0,
    STEP_AMOUNT: 0.01,
    DECIMAL_PLACES: 2,
    FLOATING_POINT_PRECISION: 0.01,
    MAX_ITEMS_DISPLAY: 10,
};

// Storage keys
export const STORAGE_KEYS = {
    CASHOUT_TRANSACTIONS: "pos-cashout-transactions",
};

// Filter configurations
export const FILTERS = {
    EXPENSE_ACCOUNTS: [
        ["root_type", "=", "Expense"],
        ["parent_account", "like", "%Indirect Expenses%"],
        ["is_group", "=", 0],
        ["name", "like", "%expenses%"],
    ],
    SUPPLIERS: [["disabled", "=", 0]],
    ACTIVE_EMPLOYEES: [["status", "=", "Active"]],
    PURCHASE_ITEMS: [["is_purchase_item", "=", 1]],
    LEAF_ITEM_GROUPS: [["is_group", "=", 0]],
    USER_EMPLOYEE: (userId) => [["user_id", "=", userId]],
};

// Field configurations
export const FIELDS = {
    SUPPLIER: ["name", "supplier_name"],
    EMPLOYEE: ["name", "employee_name", "user_id"],
    ITEM_GROUP: ["name", "item_group_name"],
};
